module.exports = __webpack_public_path__ + "static/media/banjo.7d80d9c4.svg";